import { render, staticRenderFns } from "./modal-assign-mitra.vue?vue&type=template&id=4c2cee92"
import script from "./modal-assign-mitra.vue?vue&type=script&lang=js"
export * from "./modal-assign-mitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports